module.exports = __webpack_public_path__ + "img/bg-ai-stars-mobile.1a8b364.webp";